import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/views/home/home'
import MyProducp from '@/components/views/MyProducp/MyProducp'
import newans from '@/components/views/AsnOrder/newans/newans'
import AsnOrder from '@/components/views/AsnOrder/AsnOrder'
import AnsEdit from '@/components/views/AsnOrder/Ansdetails/Ansedit'
import OrderManagement from '@/components/views/OrderManagement/OrderManagement'
import Setting from '@/components/views/Setting/Setting'
import Settingyi from '@/components/views/Setting/settingyi'
import Finance from '@/components/views/Finance/Finance'
import flowBill from '@/components/views/Finance/flowBill'
import Bill from '@/components/views/Finance/Bill'
import rechargeOrder from '@/components/views/Finance/rechargeOrder'
import myPrice from '@/components/views/Finance/myPrice'
import PriceList from '@/components/views/PriceList/PriceList'
import accountManager from '@/components/views/accountManager/accountManager'
import storage from '@/components/views/storage/storage'
import login from '@/components/views/login/login'
import Register from '@/components/views/login/Register'
import install from '@/components/views/install/install'
import shu from '../404.vue'
import {getToken} from '@/components/utils/auth'
import store from '@/store'

Vue.use(Router)
const routes = [{
  path: '*',
  redirect: '/home'
}, {
  path: '/home',
  name: 'home',
  // meta: {
  //  requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  //  },
  component: home
}, {
  path: '/404',
  name: '404',
  component: shu
},
{
  path: '/login',
  name: 'login',
  component: login
}, {
  path: '/Register',
  name: 'Register',
  component: Register
},
{
  path: '/install',
  name: 'install',
  component: install
},
{
  path: '/MyProducp',
  name: 'MyProducp',
  meta: {
    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  },
  component: MyProducp
},
{
  path: '/newans',
  name: 'newans',
  meta: {
    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  },
  component: newans
},
{
  path: '/AsnOrder',
  name: 'AsnOrder',
  meta: {
    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  },
  component: AsnOrder
},
{
  path: '/AsnOrder/edit/:asn_code',
  name: 'editOrder',
  meta: {
    requireAuth: true
  },
  component: AnsEdit
},
{
  path: '/OrderManagement',
  name: 'OrderManagement',
  meta: {
    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  },
  component: OrderManagement
},
{
  path: '/Finance',
  name: 'Finance',
  meta: {
    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  },
  component: Finance,
  redirect: '/Finance/flowBill',
  children: [
    {
      path: '/Finance/flowBill', // 流水
      name: 'flowBill',
      component: flowBill,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/Finance/bill', // 账单路由
      name: 'bill',
      component: Bill,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/Finance/rechargeOrder', // 充值订单
      name: 'rechargeOrder',
      component: rechargeOrder,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/Finance/myPrice', // 我的价格
      name: 'myPrice',
      component: myPrice,
      meta: {
        requireAuth: true
      }
    }
  ]
},
{
  path: '/Setting',
  name: 'Setting',
  meta: {
    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  },
  component: Setting
},

{
  path: '/Settingyi',
  name: 'Settingyi',
  meta: {
    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  },
  component: Settingyi
},
{
  path: '/PriceList',
  name: 'PriceList',
  meta: {
    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  },
  component: PriceList
},
{
  path: '/accountManager',
  name: 'accountManager',
  meta: {
    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  },
  component: accountManager
},
{
  path: '/storage',
  name: 'storage',
  meta: {
    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
  },
  component: storage
}
]

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requireAuth)) {
    if (store.getters.shopTokenuser) {
      next()
    } else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js